<p-dialog *ngIf="!displayEditViewDialog" [(visible)]="currentDisplay" [modal]="true" [responsive]="true" appendTo="body" [style]="{width: '55vw'}" [closable]="false">
    <ng-template pTemplate="header">
        <div class="w-100" style="display: flex; justify-content: space-between;">
            <h5 class="p-mb-0"> {{header}}
                <a *ngIf="isShow" class="btnBars p-mr-0 p-ml-2" (click)="setDataDetails()">
                    <i class="fa fa-external-link"></i>
                </a>
            </h5>
            <div class="p-d-flex">
                <div *ngIf="[objectNames.LEADS, objectNames.ACCOUNT].includes(moduleType)">
                    <p-inputSwitch class="header-switch" name="selectedStatus" [(ngModel)]="leadAccountStatus" disabled></p-inputSwitch>
                </div>
                <button pButton pRipple (click)="hideDialog()"
                class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times"></button>
            </div>
        </div>
    </ng-template>

    <div *ngIf="data">
        <div class="card" *ngIf="moduleType == objectNames.CASES">
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Case ID: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.sequenceNumber}}</p>
                </div>
                <!-- <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('ticketNo', 'Case No')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.ticketNo}}</p>
                </div> -->
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('category', 'Category')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data?.categoryName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('subCategory', 'Sub Category')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data?.subCategoryName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactName', 'Contact Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('associationName', 'Association Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.associationName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('Contact Email', 'Contact Email')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactEmailAddress}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('caseAssociationName', 'Association Type')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.caseAssociationName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('Contact Number', 'Contact Number')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactMobileNo}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('Contact Source', 'Contact Source')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.sourceName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('ticketDesc', 'Case Details')}}: </strong></p>
                </div>
                <div class="p-col-4 p-md-10">
                    <p>{{data.ticketDesc}}</p>
                </div>
            </div>
            <!-- <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Note: </strong></p>
                </div>
                <div class="p-col-8 p-md-10">
                    <p><strong>{{data.description}}</strong></p>
                </div>
            </div> -->
        </div>

        <div class="card" *ngIf="moduleType == objectNames.OPPORTUNITY">
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Opportunity ID: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.sequenceNumber}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('name', 'Opportunity Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.name}}</p>
                </div>
            </div>

            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Account Name: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data?.accountName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('pipelineName', 'Channel')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.pipelineName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('totalAmount', 'Opportunity Amount')}}:</strong>
                    </p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.totalAmount | number:'1.2-2' | currencySymbol}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('probability', 'Probability')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.probability + '%'}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Quality: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data?.ratingName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Source: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.sourceName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('forcastCategory', 'Forcast Category')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.forcastCategory}}</p>
                </div>
            </div>
            <!-- <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('price', 'Price')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.price}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Status: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.status.name}}</p>
                </div>
            </div> -->
            <!-- <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('productName', 'Product Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.productName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Unit: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.unit?.name}}</p>
                </div>
            </div> -->
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('stageName', 'Stage')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.stageName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Status: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.statusId==1? 'Active' : 'Inactive'}}</p>
                </div>
                <!-- <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('itemTotal', 'Item Total')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.itemTotal}}</p>
                </div> -->
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Close Date: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.expectedDate | date:'MM/dd/yyyy'}}</p>
                </div>
                <!-- <div class="p-col-4 p-md-2">
                    <p><strong>Number of Records: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.numberOfRecords}}</p>
                </div> -->
            </div>

            <div class="p-grid">
                <!-- <div class="p-col-4 p-md-2">
                    <p><strong>Opportunity No: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.opportunityNo}}</p>
                </div> -->
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('ownerName', 'Owner')}}:</strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.ownerName}}</p>
                </div>
            </div>

            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Opportunity Details: </strong></p>
                </div>
                <div class="p-col-8 p-md-10">
                    <p>{{data.description}}</p>
                </div>
            </div>

        </div>

        <div class="card" *ngIf="moduleType == objectNames.LEADS">
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Leads ID: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.sequenceNumber}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactFirstName', 'First Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactFirstName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactMiddleName', 'Middle Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactMiddleName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactLastName', 'Last Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactLastName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('businessName', 'Lead Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.businessName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('leadNumber', 'Lead Number')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.leadNumber}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Lead Types: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <span *ngFor="let el of data.leadTypes; let i = index;">
                        {{ el.type.name }}

                        <span *ngIf="i < data.leadTypes.length-1">
                            ,
                        </span>
                    </span>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Lead Stage: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.stageName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2 p-pr-0">
                    <p><strong>{{getLabelName('streetAddress1', 'Street Address 1')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.streetAddress1}}</p>
                </div>
                <div class="p-col-4 p-md-2 p-pr-0">
                    <p><strong>{{getLabelName('streetAddress2', 'Street Address 2')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.streetAddress2}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('state', 'State')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.state}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('country', 'Country')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.country}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Note: </strong></p>
                </div>
                <div class="p-col-8 p-md-10">
                    <p><strong>{{data.description}}</strong></p>
                </div>
            </div>
        </div>

        <div class="card" *ngIf="moduleType == objectNames.CONTACT">
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Contact ID: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.sequenceNumber }}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Contact Name: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{ [data.firstName, data.middleName, data.lastName].join(' ') }}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Association Name: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data?.associationName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Contact Source: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.source?.name}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Work Email: </strong></p>
                </div>
                <div class="p-col-8 p-md-4" *ngIf="data.contactEmails">
                    <p>{{data['email']}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactPhones', 'Phone Number')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4" *ngIf="data.contactPhones">
                    <p>{{data.phone.number | phoneNumber: data.phone.code }}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Contact Type: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactType?.name}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Note: </strong></p>
                </div>
                <div class="p-col-8 p-md-10">
                    <p><strong>{{data.description}}</strong></p>
                </div>
            </div>
        </div>

        <div class="card" *ngIf="moduleType == objectNames.ACCOUNT">
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Account ID: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.sequenceNumber}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Parent Account: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.parentAccount?.name}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactFirstName', 'First Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactFirstName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactLastName', 'Last Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactLastName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('businessName', 'Account Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.businessName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('accountNumber', 'Account Number')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.accountNumber}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('contactname', 'Contact Name')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.contactname}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>Account Type(s): </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <span *ngFor="let elem of data.accountTypes; let i = index;">
                        {{ elem.type.name }}

                        <span *ngIf="i+1 < data.accountTypes.length">
                            ,
                        </span>
                    </span>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Account Source: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.source?.name || data.sourceName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('industryName', 'Industry')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.industryName}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Rating: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.rating?.name || data.ratingName}}</p>
                </div>
                <div class="p-col-4 p-md-2">
                    <p><strong>{{getLabelName('country', 'Country')}}: </strong></p>
                </div>
                <div class="p-col-8 p-md-4">
                    <p>{{data.country}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4 p-md-2">
                    <p><strong>Note: </strong></p>
                </div>
                <div class="p-col-8 p-md-10">
                    <p><strong>{{data.description}}</strong></p>
                </div>
            </div>
        </div>

        <!-- <div class="header">
            <h5>Comment</h5>
        </div>

        <div class="card" *ngIf="moduleType == objectNames.CASES">
            <div *ngFor="let status of data.comments">
                <div class="p-p-2 border-bottom">
                    <p-header class="p-d-flex p-jc-between" style="width: 100%">
                        <span><strong>{{ status.createdByName }}</strong></span>
                        <span>{{ status.createdDate | localDate }}</span>
                    </p-header>
                    <p class="p-mb-0">Comments: {{ status.description }}</p>
                </div>
            </div>
            <ng-container *ngIf="!data.comments || !data.comments.length">
                <div class="p-grid statuses">
                    <div class="p-col-12">
                        <strong>Comment is empty.</strong>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="card" *ngIf="moduleType == objectNames.OPPORTUNITY">
            <div *ngFor="let status of data.comments">
                <div class="p-p-2 border-bottom">
                    <p-header class="p-d-flex p-jc-between" style="width: 100%">
                        <span><strong>{{ status.createdByName }}</strong></span>
                        <span>{{ status.createdDate | localDate }}</span>
                    </p-header>
                    <p class="p-mb-0">Comments: {{ status.description }}</p>
                </div>
            </div>
            <ng-container *ngIf="!data.comments || !data.comments.length">
                <div class="p-grid statuses">
                    <div class="p-col-12">
                        <strong>Comment is empty.</strong>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="card" *ngIf="moduleType == objectNames.LEADS">
            <div *ngFor="let status of data.comments">
                <div class="p-p-2 border-bottom">
                    <p-header class="p-d-flex p-jc-between" style="width: 100%">
                        <span><strong>{{ status.createdByName }}</strong></span>
                        <span>{{ status.createdDate | localDate }}</span>
                    </p-header>
                    <p class="p-mb-0">Comments: {{ status.description }}</p>
                </div>
            </div>
            <ng-container *ngIf="!data.comments || !data.comments.length">
                <div class="p-grid statuses">
                    <div class="p-col-12">
                        <strong>Comment is empty.</strong>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="card" *ngIf="moduleType == objectNames.CONTACT">
            <div *ngFor="let status of data.comments">
                <div class="p-p-2 border-bottom">
                    <p-header class="p-d-flex p-jc-between" style="width: 100%">
                        <span><strong>{{ status.createdByName }}</strong></span>
                        <span>{{ status.createdDate | localDate }}</span>
                    </p-header>
                    <p class="p-mb-0">Comments: {{ status.description }}</p>
                </div>
            </div>
            <ng-container *ngIf="!data.comments || !data.comments.length">
                <div class="p-grid statuses">
                    <div class="p-col-12">
                        <strong>Comment is empty.</strong>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="card" *ngIf="moduleType == objectNames.ACCOUNT">
            <div *ngFor="let status of data.comments">
                <div class="p-p-2 border-bottom">
                    <p-header class="p-d-flex p-jc-between" style="width: 100%">
                        <span><strong>{{ status.createdByName }}</strong></span>
                        <span>{{ status.createdDate | localDate }}</span>
                    </p-header>
                    <p class="p-mb-0">Comments: {{ status.description }}</p>
                </div>
            </div>
            <ng-container *ngIf="!data.comments || !data.comments.length">
                <div class="p-grid statuses">
                    <div class="p-col-12">
                        <strong>Comment is empty.</strong>
                    </div>
                </div>
            </ng-container>
        </div> -->
    </div>
</p-dialog>
<app-edit-account *ngIf="displayEditViewDialog && moduleType == objectNames.ACCOUNT" [displayEditViewDialog]="moduleType == objectNames.ACCOUNT" [displayView]="true"
           [selectedAccountId]="dataId" 
           (closeModal)="closeAccountViewEditModal()">
        </app-edit-account>
<p-toast position="top-right" [baseZIndex]="10000"></p-toast>
